import { BuyerIntentLeadClick } from 'components/BuyerIntent';
import Typography from 'components/Typography';
import { useEventContext } from 'context/EventContext';
import usePplForm from 'hooks/usePplForm';

import advisorImg from './assets/advisor.png';

import classes from './PPLSimpleBanner.module.scss';

const PhoneIcon = () => (
  <svg
    viewBox="0 0 16.0083 16.0001"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    aria-hidden="true"
  >
    <path
      d="M13.7585 15.9501C13.6885 15.9501 13.6185 15.9501 13.5485 15.9501C11.1985 15.6901 8.91854 14.8801 6.93854 13.6001C5.10854 12.4401 3.51854 10.8501 2.35854 9.01009C1.07854 7.03009 0.268537 4.74009 0.00853746 2.39009C-0.0414625 1.80009 0.128537 1.23009 0.508537 0.780092C0.888537 0.340092 1.40854 0.0600916 1.99854 9.15885e-05C2.05854 9.15885e-05 2.11854 9.15885e-05 2.18854 9.15885e-05H4.36854C5.48854 -0.00990841 6.38854 0.800092 6.53854 1.88009C6.62854 2.53009 6.77854 3.16009 7.00854 3.77009C7.30854 4.56009 7.11854 5.47009 6.51854 6.07009L5.99854 6.59009C6.85854 7.93009 7.98854 9.07009 9.33854 9.93009L9.85854 9.41009C10.4685 8.81009 11.3685 8.62009 12.1685 8.92009C12.7685 9.15009 13.4085 9.30009 14.0485 9.39009C15.1485 9.55009 15.9585 10.4901 15.9285 11.6001V13.7701C15.9285 14.3501 15.7085 14.9001 15.2985 15.3101C14.8885 15.7201 14.3385 15.9501 13.7585 15.9601V15.9501ZM4.38854 1.45009H2.18854C1.92854 1.47009 1.75854 1.56009 1.62854 1.71009C1.50854 1.86009 1.44854 2.05009 1.45854 2.24009C1.67854 4.35009 2.41854 6.42009 3.57854 8.22009C4.63854 9.88009 6.06854 11.3101 7.71854 12.3701C9.50854 13.5301 11.5685 14.2601 13.6885 14.4901C14.1485 14.4901 14.4685 14.1601 14.4685 13.7601V11.5701C14.4685 11.5701 14.4685 11.5601 14.4685 11.5501C14.4685 11.1801 14.2085 10.8601 13.8385 10.8101C13.0885 10.7101 12.3485 10.5301 11.6385 10.2601C11.3685 10.1601 11.0685 10.2201 10.8685 10.4201L9.94854 11.3401C9.71854 11.5701 9.35854 11.6201 9.07854 11.4601C7.13854 10.3601 5.53854 8.76009 4.43854 6.82009C4.27854 6.53009 4.32854 6.18009 4.55854 5.95009L5.47854 5.03009C5.67854 4.83009 5.73854 4.53009 5.63854 4.27009C5.36854 3.56009 5.18854 2.82009 5.08854 2.07009C5.03854 1.72009 4.72854 1.45009 4.36854 1.45009H4.38854Z"
      fill="currentColor"
    />
  </svg>
);

const PPLSimpleBanner = ({
  listing,
  boldText = 'Weigh the pros and cons with an expert.',
  description = " Tell an advisor what matters most to you: they'll help you evaluate the pros and cons and narrow down your shortlist.",
  sourceLocation = 'listing-detail-v1/ppl-simple-banner:get-free-advice',
  engagementDetails = 'button_get-free-advice',
}) => {
  const { addEvent } = useEventContext();

  const { buyerIntentProductId, buyerIntentCategoryId, handleClick } =
    usePplForm({
      productId: listing.global_product_id,
      sourceLocation,
      formTemplate: 'faststart',
    });

  return (
    <BuyerIntentLeadClick
      productId={buyerIntentProductId}
      categoryId={buyerIntentCategoryId}
      sourceLocation={sourceLocation}
    >
      <div className={classes.root}>
        <Typography component="p" className={classes.text}>
          <span className={classes.bold}>{boldText}</span>
          {description}
        </Typography>
        <div className={classes.actions}>
          <div className={classes.advisorPhotoWrapper}>
            {/* biome-ignore lint/nursery/noImgElement: static asset, no Next.js Image needed */}
            <img src={advisorImg.src} alt="" className={classes.advisorPhoto} />
          </div>
          <button
            type="button"
            className={classes.button}
            onClick={handleClick}
            {...addEvent({
              engagementComponent: 'ppl_banner',
              engagementDestination: 'go-to_ppl-faststart-form',
              engagementDetails,
              name: 'ppl_cta',
            })}
          >
            <PhoneIcon />
            Get Free Advice
          </button>
        </div>
      </div>
    </BuyerIntentLeadClick>
  );
};

export default PPLSimpleBanner;
